import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BrowserStorageService {
  browserStorageAvailable: boolean = false;
  constructor() {
    this.detectLocalStorage();
   }
   detectLocalStorage() {
     var localStorage: any;
     try {
       localStorage = window.localStorage;
     } catch (error) {
       // no local storage available
     }
     this.browserStorageAvailable = localStorage !== null;
   }
   public isAvailable(){
     return this.browserStorageAvailable;
   }
   public savePermanent(key: string, value: any){
     localStorage.setItem(key, value);
   }
   public saveSession(key: string, value: any){
     sessionStorage.setItem(key, value);
   }
   public getValue(key: string){
     if (!this.browserStorageAvailable) return "";
     var value = sessionStorage.getItem(key);
     if (value == null){
       value = localStorage.getItem(key);
     }
     if (value == null) return "";
     return value;
   }
   public getPermanentValue(key: string){
    if (!this.browserStorageAvailable) return "";
    var value = localStorage.getItem(key);
    if (value == null) return "";
    return value;
  }
  public getSessionValue(key: string){
    if (!this.browserStorageAvailable) return "";
    var value = sessionStorage.getItem(key);
    if (value == null) return "";
    return value;
  }
}
